import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Overlayable} from 'src/app/interfaces/overlayable';
import {TimerButtonService} from "../../services/timer-button.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {TimerButtonState} from "../../enums/timer-button-state";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-teacher-timer-stop-dialog',
  templateUrl: './teacher-timer-stop-dialog.component.html',
  styleUrls: ['./teacher-timer-stop-dialog.component.scss']
})
export class TeacherTimerStopDialogComponent implements Overlayable, OnInit {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  currentLabel = "00:00";
  constructor(private timerButtonService: TimerButtonService) {
  }

  ngOnInit() {
    this.timerButtonService.onUpdate().pipe(untilDestroyed(this)).subscribe((newValue) => {
      // console.log(newValue);
      if(newValue.state === TimerButtonState.PLAY) {
        const totalSeconds = Math.floor(newValue.timerValue);

        const minutes = ('0' + Math.floor(totalSeconds / 60).toString()).slice(-2);
        const seconds = ('0' + (totalSeconds % 60).toString()).slice(-2);
        this.currentLabel = `${minutes}:${seconds}`;

      } else {
        this.currentLabel = "00:00";
      }
    })
  }
}
